module.exports = __webpack_public_path__ + "static/img/slaSurface1.e6e564f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slaSurface1.png
// module id = 77KD
// module chunks = 2